import type { GraphResponse } from '@agentwiki/shared'

interface GraphMiniMapProps {
  data: GraphResponse
  selectedNodes: string[]
}

export function GraphMiniMap({ data, selectedNodes }: GraphMiniMapProps) {
  const nodes = data.nodes.slice(0, 80)
  const selected = new Set(selectedNodes)
  const center = 48
  const radius = 34

  return (
    <div className="absolute right-4 top-4 hidden w-32 rounded-lg border border-white/[0.06] bg-surface-1/90 p-2 backdrop-blur-sm lg:block">
      <div className="mb-1 flex items-center justify-between text-[10px] text-neutral-500">
        <span>Overview</span>
        <span>{data.stats.nodeCount}</span>
      </div>
      <svg viewBox="0 0 96 96" className="h-24 w-full" role="img" aria-label="Graph overview">
        <circle cx={center} cy={center} r={radius + 6} className="fill-surface-2" />
        {nodes.map((node, index) => {
          const angle = (index / Math.max(nodes.length, 1)) * Math.PI * 2
          const degreeOffset = Math.min(node.data.degree ?? 0, 10)
          const x = center + Math.cos(angle) * (radius - degreeOffset)
          const y = center + Math.sin(angle) * (radius - degreeOffset)
          const isSelected = selected.has(node.data.id)
          return (
            <circle
              key={node.data.id}
              cx={x}
              cy={y}
              r={isSelected ? 3 : 1.7}
              className={isSelected ? 'fill-brand-400' : 'fill-neutral-500'}
            />
          )
        })}
      </svg>
    </div>
  )
}
